import React from "react";
import Container from "@material-ui/core/Container";
import LandingPageHeader from "../../LandingPage/views/LandingPageHeader";
import LandingPageFooter from "../../LandingPage/views/LandingPageFooter";

//CSS import
import "./About.css";

const About = () => {
  return (
    <React.Fragment>
      <LandingPageHeader NavButton="about"/>
      {/* Flex Container */}
      <div className="flex-container">
        {/* Home Section */}

        <section about="home" style={{ padding: "30px" }}>
          <h1 className="heading">About Us</h1>
          <Container>
            <p className="paragraph">
              Aims was created by Sivaramakrishna who has 15 years of Experience as a Pharmacy Manager who has bought many ideas to live. 
              Aims was created focusing on the business owners to see and forecast the business in a single dashboard which can save their 
              time to invest in other activities rather than stressing on the pharmacy management. 
            </p>
            <p className="paragraph">
              Aims is all about the system running the 
              show not by an individual. After spending a lot of time working in the pharmacy I had identified the blind spot where the business 
              owners were not focused on. Throughout my experience I had noticed that all the Business owners were very much focused on the revenue 
              generating part of the business and kept themselves blinded over the revenue dripping part. 
            </p>
            <p className="paragraph">
              Aims is all about helping the business owners 
              to bring the business analytics to a single dashboard. I had compiled all my experience as a Pharmacy Manager and business development and 
              invested in Aims to empower your employees to do their best every day. Unleashing their inner awesomeness to save you time, improve 
              customer-centricity, and grow your pharmacy business.
            </p>            
          </Container>
          {/* <p style={{ paddingBottom: "30px", }}>
            The pace of Today Pharmacy business is swiftly changing than before
            and in order to keep up to date, real-time data should be at your
            fingertips, you need seamless applications that can Sync your
            Current Workflow and provide the experience your Team expects.
            However, traditional IT architectures are simply not keeping pace to
            meet today's challenges of time and scale. Aims Rx is a Event-driven
            architecture (EDA) enables your business Managing applications to be
            more agile, scalable, and responsive to your needs so that you can
            Streamline you current Activities and focus on areas where your
            presence is much needed.
          </p>
          <p style={{ paddingBottom: "30px" }}>
            One of the most crucial factors in any Retail Sector is inventory.
            Pharmacies are striving to keep Enough Inventory on shelf. In
            Today's World Pharmacy Owner are facing critical Pressure on the
            reimbursement and DIR Fees, they Desire as little cash as possible
            tied up in Their Inventory. None of the Pharmacy Owner's like their
            Capital held captive in inventory. Saving the capital can be
            utilized for the business growth.
          </p>
          <p style={{ paddingBottom: "30px" }}>
            Everyday Pharmacies are seeing new Compliances and New Challenges,
            running An Independent pharmacy became a Hornet's nest. Pharmacies
            are seeing decline in reimbursements and incline on DIR Fees and
            expenses. It is getting difficult to get focused on day to day
            operations Most of us were focusing on the Compliance and how to
            generate the revenue on the other side leaving the holes open.
            AimsRx is powerful tools to fill the holes and let you focus on the
            other side of the aisle
          </p>
          <p style={{ paddingBottom: "30px" }}>
            As you look to gain productivity and agility AIMS can handle your
            Day to day operations and break you down from individual driven
            system to system Driven Individuals
          </p>
          <p style={{ paddingBottom: "30px" }}>
            Data is the key Asset of any organization if you can view in a right
            perspective you can make right decisions AIMS RX is a revolutionary
            tool which changes the way Organizations Analyze and manage their
            data.
          </p>
          <p style={{ paddingBottom: "30px" }}>
            Most of the small business rely on minimum wage employees As the
            Govt. is moving forward on increasing the minimum wages it is
            impacting the business owners to thrive on the payroll. Decreasing
            the man power will not increase the productivity of an organization
            but utilizing and managing the manpower in a right way can improve
            the productivity and revenue Aims Rx helps you to get the most of
            your payroll.
          </p>
          <p style={{ paddingBottom: "30px" }}>
            Most of the small business rely on minimum wage employees As the
            Govt. is moving forward on increasing the minimum wages it is
            impacting the business owners to thrive on the payroll. Decreasing
            the man power will not increase the productivity of an organization
            but utilizing and managing the manpower in a right way can improve
            the productivity and revenue Aims Rx helps you to get the most of
            your payroll.
          </p> */}
        </section>
        {/* Process 1 Section */}
      </div>
      <LandingPageFooter />
    </React.Fragment>
  );
};

export default About;
